import React from "react";
import ReactECharts from "echarts-for-react";
import { groupSeriesXY } from "../../utils/echartsSeries.js";

function hexToRgb(hex) {
  const v = hex.replace("#", "");
  return [parseInt(v.slice(0, 2), 16), parseInt(v.slice(2, 4), 16), parseInt(v.slice(4, 6), 16)];
}
function mixWith(hex, target, t) {
  const [r, g, b] = hexToRgb(hex);
  const [tr, tg, tb] = hexToRgb(target);
  const mix = (a, c) => Math.round(a + (c - a) * t);
  return `#${[mix(r, tr), mix(g, tg), mix(b, tb)].map((v) => v.toString(16).padStart(2, "0")).join("")}`;
}

// Même principe que sur PhenoChart : ordre canonique des horizons, qu'ils
// soient exprimés en années (RCP classique) ou en niveaux TRACC.
const ORDRE_HORIZON = {
  2020: 0, reference: 0,
  2035: 1, "+2": 1,
  2050: 2, "+2.7": 2,
};

export default function AleaChart({ data, color = "#3182bd", title }) {
  // Horizons réellement présents dans les données, triés dans le bon ordre
  // (peu importe qu'ils soient numériques ou textuels).
  const categories = [...new Set(data.map((d) => d.YearGroup))].sort(
    (a, b) => (ORDRE_HORIZON[a] ?? 99) - (ORDRE_HORIZON[b] ?? 99)
  );

  const groups = groupSeriesXY(data, { xKey: "YearGroup", groupKey: "stat", valueKey: "val" });

  // Min = version claire, Moy = couleur de base, Max = version foncée
  const palStat = {
    Min: mixWith(color, "#ffffff", 0.55),
    Moy: color,
    Max: mixWith(color, "#000000", 0.35),
  };

  const series = groups.map(({ group, points }) => ({
    name: group,
    type: "line",
    symbol: "circle",
    smoothed: true,
    symbolSize: 6,
    lineStyle: { width: 2, color: palStat[group] || "#888" },
    itemStyle: { color: palStat[group] || "#888" },
    // aligné positionnellement sur "categories" (axe catégoriel, pas numérique)
    data: categories.map((cat) => {
      const point = points.find((p) => p.x === cat);
      return point ? point.y : null;
    }),
  }));

  const option = {
    title: title ? { text: title, left: "center", textStyle: { fontSize: 13 } } : undefined,

    legend: { bottom: 0, itemWidth: 14, itemHeight: 10, textStyle: { fontSize: 15 } },
    grid: { left: 45, right: 15, top: title ? 40 : 20, bottom: 40, containLabel: true },
    xAxis: {
      type: "category",
      name: "Horizon",
      data: categories.map(String),
      axisLabel: { fontSize: 14, interval: 0 },
    },
    yAxis: { type: "value", name: "Jours / an", nameLocation: "middle", nameGap: 35, nameTextStyle: { fontSize: 10 } },
    series,
  };

  return <ReactECharts option={option} style={{ height: 420 }} notMerge lazyUpdate />;
}